<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">实测数据</div>
    </div>
    <div class="modul-search">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="桥梁名称">
          <el-select
            v-model="bridgeName"
            @change="bridgeChange"
            filterable
            clearable
            placeholder="请选择"
            style="width: 120px"
          >
            <el-option
              v-for="(item, index) in bridgeData"
              :key="index"
              :label="item.bridgeName"
              :value="item.bridgeUuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select
            v-model="equipmentType"
            @change="equipmentTypeChange"
            filterable
            clearable
            placeholder="请选择"
            style="width: 120px"
          >
            <el-option
              v-for="(item, index) in equipmentTypes"
              :key="index"
              :label="item.equipmentTypeName"
              :value="item.equipmentTypeUuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备别名">
          <el-select
            v-model="formInline.equipmentAnotherName"
            @change="equipmentTypeListChange"
            filterable
            clearable
            placeholder="请选择"
            style="width: 200px"
          >
            <el-option
              v-for="(item, index) in equipmentTypeList"
              :key="index"
              :label="item.equipmentAnotherName"
              :value="item.equipmentAnotherName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据类型">
          <el-select
            v-model="formInline.dataType"
            @change="dataTypeChange"
            filterable
            clearable
            placeholder="请选择"
            style="width: 100px"
          >
            <el-option
              v-for="(item, index) in selectedDataType"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="time"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSubmit">查询</el-button>
          <el-button
            @click="
              addVisible = true
              getBridgeTree()
            "
            >导出
          </el-button>
        </el-form-item>
      </el-form>
      <div>
        <!-- <el-button @click="addItem">新增</el-button> -->
        <!-- <el-button
          @click="
            addVisible = true
            getBridgeTree()
          "
          >导出
        </el-button> -->
      </div>
    </div>
    <div class="modul-content">
      <div class="echarts-box">
        <div class="modul-content-title">数据曲线图</div>
        <div class="cardInfoBox">
          <div class="card-item">
            <span>最大值</span>
            <template v-if="mathObj.max.length">
              <span style="color: #F34D59;">{{ mathObj.max[0].dataValue }}</span>
              <el-dropdown :disabled="mathObj.max.length == 1">
                <el-badge :hidden="mathObj.max.length == 1" :value="mathObj.max.length">
                  <div>{{ mathObj.max[0].createTime }}
                  </div>
                </el-badge>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(e,i) in mathObj.max" :key="i">{{ e.createTime }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <span v-else></span>
          </div>
          <div class="card-item">
            <span>最小值</span>
             <template v-if="mathObj.min.length">
              <span style="color: #2F7FF0;">{{ mathObj.min[0].dataValue }}</span>
              <el-dropdown :disabled="mathObj.min.length == 1">
                <el-badge :hidden="mathObj.min.length == 1" :value="mathObj.min.length">
                  <div>{{ mathObj.min[0].createTime }}
                  </div>
                </el-badge>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(e,i) in mathObj.min" :key="i">{{ e.createTime }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <span v-else></span>
          </div>
          <div class="card-item">
            <span>绝对值最大值</span>
            <template v-if="mathObj.absMax.length">
              <span>{{ mathObj.abs }}</span>
              <el-dropdown :disabled="mathObj.absMax.length == 1">
                <el-badge :hidden="mathObj.absMax.length == 1" :value="mathObj.absMax.length">
                  <div>{{ mathObj.absMax[0].createTime }}
                  </div>
                </el-badge>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(e,i) in mathObj.absMax" :key="i">{{ e.createTime }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <span v-else></span>
          </div>
          <div class="card-item">
            <span>均值</span>
            <span>{{ mathObj.mean }}</span>
          </div>
          <div class="card-item">
            <span>标准差</span>
            <span>{{ mathObj.std }}</span>
          </div>
          <div class="card-item">
            <span>峰峰值</span>
            <span>{{ mathObj.peak }}</span>
          </div>
        </div>


        <div class="charts"></div>
      </div>
      <div class="table-box">
        <div class="modul-content-title">数据清单</div>
        <el-table
          v-loading="loading"
          :data="tableData"
          :header-cell-style="{'text-align': 'center'}"
          :cell-style="{'text-align': 'center'}"
          height="180"
          border
          style="width: 100%"
        >
          <el-table-column label="编号" type="index" width="80px">
          </el-table-column>
          <el-table-column label="设备别名" prop="equipmentAnotherName">
          </el-table-column>
          <el-table-column label="数值" prop="dataValue"> </el-table-column>
          <el-table-column
            label="数据类型"
            prop="dataTypeName"
            min-width="50px"
          >
          </el-table-column>
          <el-table-column label="单位" prop="unit" min-width="50px">
          </el-table-column>
          <el-table-column label="单位名称" prop="unitName" min-width="50px">
          </el-table-column>
          <el-table-column label="采集时间" prop="createTime">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="text-align: center; margin: 20px 0 0">
      <!--描述：分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[5, 10, 15, 50, 200]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="addVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      @close="cancelDialog()"
      width="65%"
    >
      <span slot="title">
        <div class="modul-top1">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">数据导出</div>
        </div>
      </span>
      <el-form
        :inline="true"
        label-width="100px"
        :model="exportForm"
        :rules="rules"
        ref="ruleForm"
        style="text-align: left"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="时间" prop="startTime">
              <el-date-picker
                v-model="exportForm.startTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="24">
            <el-form-item label="桥梁数据">
              <div
                class="bridge-data"
                v-loading="bridgeLoading"
                element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background
              >
                <div
                  v-for="(item, index) in treeData"
                  :key="index"
                  class="bridge-list"
                >
                  <el-checkbox-group
                    v-model="checkList"
                    @change="
                      (e, item, index) => bridgeNameChange(e, treeData, index)
                    "
                  >
                    <el-checkbox :label="item.bridgeUuid">{{
                      item.bridgeName
                    }}</el-checkbox>
                  </el-checkbox-group>
                  <el-tree
                    ref="tree"
                    :data="item.children"
                    node-key="value"
                    show-checkbox
                    highlight-current
                    style="height: calc(100% - 50px); overflow: overlay"
                    @check="currentChecked"
                  >
                  </el-tree>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
        style="right: 20px; bottom: 20px; position: absolute"
      >
        <el-button type="primary" :loading="btnLoading" @click="add_sure()"
          >确 定</el-button
        >
        <el-button @click="cancelDialog()">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {EleResize} from '../../../utils/resize'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'ZuijiBridegIndex',
  data() {
    return {
      bridgeLoading: true,
      btnLoading: false,
      checkList: [],
      addVisible: false,
      bridgeData: [],
      bridgeUuid: '',
      equipmentType: '',
      equipmentTypeUuid: '',
      equipmentTypes: [],
      equipmentTypeList: [],
      time: ['', ''],
      time1: [],
      listOptions: [],
      dataTypeList: [
        {
          equipmentTypeUuid: '6fc26b612a61463dbf4208a0a041135c',
          equipmentTypeName: '表面应变计',
          dataType: [
            {label: '应变', value: 'YBJ_RATE_OFFSET'},
            {label: '应变频率', value: 'YBJ_RATE'},
            {label: '应变温度', value: 'TMP'}
          ]
        },
        {
          equipmentTypeUuid: '7472a8504ee5470799ebf21427ba73cc',
          equipmentTypeName: '环境温湿度',
          dataType: [
            {label: '温度', value: 'TMP'},
            {label: '湿度', value: 'HR'}
          ]
        },
        {
          equipmentTypeUuid: 'a278203311174465bc8ae95977334c21',
          equipmentTypeName: '静力水准仪',
          dataType: [
            {label: '位移', value: 'STATIC_LEVEL_OFFSET'},
            {label: '静力水准', value: 'STATIC_LEVEL'}
          ]
        },
        {
          equipmentTypeUuid: 'aad5b37a38fa4ede9c31c274c278bcf4',
          equipmentTypeName: 'GNSS',
          dataType: [
            {label: '位移X', value: 'GNSS_X_OFFSET'},
            {label: '位移Y', value: 'GNSS_Y_OFFSET'},
            {label: '位移Z', value: 'GNSS_Z_OFFSET'},
            {label: 'GNSS_X', value: 'GNSS_X'},
            {label: 'GNSS_Y', value: 'GNSS_Y'},
            {label: 'GNSS_Z', value: 'GNSS_Z'}
          ]
        },
        {
          equipmentTypeUuid: 'd67137e51312417284d1206d657736f3',
          equipmentTypeName: '索力加速度计',
          dataType: [{label: 'CABLE_FORCE', value: 'CABLE_FORCE'}]
        },
        {
          equipmentTypeUuid: 'eada02b7cdde49b582ab9afbb91d2b84',
          equipmentTypeName: '振动加速度计',
          dataType: [
            {label: '加速度峰值', value: 'PV'},
            {label: '加速度峰峰值', value: 'PPV'},
            {label: '加速度有效值', value: 'TRMS'}
          ]
        },
        {
          equipmentTypeUuid: 'd5f1014f044a47aa8f8b556060f4b90f',
          equipmentTypeName: '液位计',
          dataType: [
            {label: '液位', value: 'WATER_LEVEL'},
          ]
        }
      ],
      selectedDataType: [],
      option: {
        color: ['#5AD8A6', '#5B8FF9'],
        grid: {
          top: '15%',
          left: '5%',
          right: '5%'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
              type: 'cross',
              label: {
                  backgroundColor: '#6a7985'
              }
          }
        },
        legend: {
          right: '5%',
          // x: 'right',
          icon: 'rect',
          itemGap: 20, //各个item之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。
          itemWidth: 12, // 图例图形宽度
          itemHeight: 10 // 图例图形高度
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            //x轴刻度相关设置
            alignWithLabel: true
          },
          axisLabel: {
            color: '#999',
            show: true,
            fontSize: 12,
            lineHeight: 20,
            formatter: function (value) {
              var ret = '' //拼接加\n返回的类目项
              var maxLength = 10 //每项显示文字个数
              var valLength = value.length //X轴类目项的文字个数
              var rowN = Math.ceil(valLength / maxLength) //类目项需要换行的行数   //如果类目项的文字大于5,
              if (rowN > 1) {
                for (var i = 0; i < rowN; i++) {
                  var temp = '' //每次截取的字符串
                  var start = i * maxLength //开始截取的位置
                  var end = start + maxLength //结束截取的位置   //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                  temp = value.substring(start, end) + '\n'
                  ret += temp //凭借最终的字符串
                }
                return ret
              } else {
                return value
              }
            }
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            // showSymbol: false,
            clip: true,
            data: [],
            type: 'line',
            symbolSize: [10, 10],
            itemStyle: {
              // color: 'red'
            }
          }
        ]
      },
      formInline: {
        pageSize: 50,
        pageNum: 1 //当前页数
      },
      total: 0,
      bridgeName: '',
      //
      echart: null,
      // 表格
      loading: false,
      // 分页器
      pagination: {
        pageSize: 50,
        pageNum: 1 //当前页数
      },
      tableData: [],
      exportForm: {
        startTime: [],
        endTime: '',
        bridgeUuidList: [],
        equipmentUuidList: []
      },
      rules: {
        startTime: [
          {
            type: 'array',
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }
        ]
      },
      treeData: [],
      bridgeUuidList: [],
      mathObj:{
        max: [],
        min: [],
        absMax: [],
        mean: '-',
        std: '-',
        peak:'-'
      },
    }
  },

  async mounted() {
    // 创建ECharts实例
    this.ChartOne()
    // 获取-桥梁录入信息
    this.getBiBridgeBoPage()
    // 获取实测数据
    if (!this.formInline.startTime) {
      this.formInline.startTime =
        moment().add(-6, 'd').format('YYYY-MM-DD') + ' 00:00:00'
      this.formInline.endTime = moment().format('YYYY-MM-DD') + ' 23:59:59'
      this.time = [this.formInline.startTime, this.formInline.endTime]
    }
    // this.getSensorByNameAndCreateTime()
    // 获取桥梁信息树结构
    // this.getBridgeTree();
  },
  watch: {
    path(one, two) {
      this.formInline = {}
    }
  },
  computed: {
    path() {
      return this.$route.path
    },
    api() {
      return this.$config.host
    }
  },
  methods: {
    // 获取选中的节点
    currentChecked(nodeObj, selectedObj) {
      console.log(nodeObj)
      console.log(selectedObj)
      this.exportForm.equipmentUuidList = selectedObj.checkedKeys
    },
    // 桥梁选择
    bridgeNameChange(e, item, index) {
      console.log(e)
      console.log(item)
      console.log(index)
      this.exportForm.bridgeUuidList = e
      // console.log(e);
      // this.exportForm.bridgeUuidList = e;
      // if (e.length > 0) {
      // 	this.treeData.map(item => {
      // 		if (item.bridgeUuid == e) {
      // 			item.children.map(item1 => {
      // 				item1.disabled = false;
      // 				item1.children.map(item2 => {
      // 					item2.disabled = false;
      // 				})
      // 			})
      // 			console.log(item);
      // 		}
      // 	})
      // } else {
      // 	this.treeData.map(item => {
      // 		if (item.bridgeUuid == e) {
      // 			item.children.map(item1 => {
      // 				item1.disabled = true;
      // 				item1.children.map(item2 => {
      // 					item2.disabled = true;
      // 				})
      // 			})
      // 			console.log(item);
      // 		}
      // 	})
      // }
    },
    // 导出
    add_sure() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.exportForm.bridgeUuidList.length == 0) {
            this.$message.error('请选择相关桥梁名称')
            return false
          }
          let data = {
            ...this.exportForm,
            startTime: JSON.parse(JSON.stringify(this.exportForm.startTime[0])),
            endTime: JSON.parse(JSON.stringify(this.exportForm.startTime[1]))
          }
          this.btnLoading = true
          this.exportItem(data)
          console.log(data)
        }
      })
    },
    // 取消
    cancelDialog() {
      // 关闭校验
      this.$refs.ruleForm.resetFields()
      this.treeData = []
      // this.$refs.tree.setCheckedKeys();
      this.addVisible = false
    },
    // 查询时间选择
    timeChange(e) {
      console.log(e)
      let time = JSON.parse(JSON.stringify(e))
      if (time != undefined && time.length > 0) {
        this.formInline.startTime = time[0]
        this.formInline.endTime = time[1]
      } else {
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      this.onSubmit()
    },
    // 获取桥梁树结构
    async getBridgeTree() {
      let data = {
        pageNum: 1,
        pageSize: 99999
      }
      const res = await this.$api.sendPost('/dataDhSensor/getBridgeTree', data)
      console.log(res)
      if (res.errcode == 0) {
        this.bridgeLoading = false
        this.treeData = res.data.list
      } else {
        this.treeData = []
      }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.getSensorByNameAndCreateTime(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.formInline.pageNum = val
      this.getSensorByNameAndCreateTime()
    },
    // 桥梁名称选择
    async bridgeChange(e) {
      this.$set(this.formInline, 'equipmentAnotherName', '')
      this.equipmentType = ''
      this.equipmentTypeUuid = ''
      this.bridgeUuid = e
      const res = await this.$api.sendGet(
        '/biBridge/getBridgeEquipmentTypeScreenList',
        {
          bridgeUuid: e
        }
      )
      if (res.errcode === 0) {
        this.equipmentTypes = res.data
        this.equipmentType = res.data[0].equipmentTypeUuid
        this.formInline.equipmentType = this.equipmentType
        this.equipmentTypeChange(this.equipmentType)
      } else {
        this.equipmentTypes = []
      }
    },
    // 设备类型选择
    async equipmentTypeChange(e) {
      this.$set(this.formInline, 'equipmentAnotherName', '')
      this.equipmentTypeList = []
      this.equipmentTypeUuid = e
      this.selectedDataType = this.dataTypeList.find(
        (item) => item.equipmentTypeUuid === e
      ).dataType
      let item = this.equipmentTypes.find(k => k.equipmentTypeUuid == e)
      console.log(item,"itme")
      if(item && item.equipmentTypeName == "桥面线形"){
        console.log(this.selectedDataType)
        this.formInline.dataType = this.selectedDataType[1].value
      }else if(item && item.equipmentTypeName == "表面应变"){
        this.formInline.dataType = this.selectedDataType[1].value
      }else{
        this.formInline.dataType = this.selectedDataType[0].value
      }
      
      const res = await this.$api.sendGet(
        '/biBridge/getEquipmentByBiBridgeAndEquipmentTypeUuid',
        {
          bridgeUuid: this.bridgeUuid,
          equipmentTypeUuid: e
        }
      )
      if (res.errcode === 0) {
        this.equipmentTypeList = res.data
        this.formInline.equipmentAnotherName =
          this.equipmentTypeList[0].equipmentAnotherName
        this.onSubmit()
      } else {
        this.equipmentTypeList = []
      }
    },
    // 设备列表选择
    equipmentTypeListChange(e) {
      this.formInline.equipmentAnotherName = e
      this.onSubmit()
    },
    // 下拉选择数据类型
    dataTypeChange(e) {
      this.formInline.dataType = e
      this.onSubmit()
    },
    // 获取-桥梁录入信息
    async getBiBridgeBoPage() {
      let data = {
        pageNum: 1,
        pageSize: 99999
      }
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          if (res.data && res.data.list.length > 0) {
            this.bridgeData = [...res.data.list]
            this.formInline.bridgeName = res.data.list[0].bridgeUuid
            this.bridgeName = res.data.list[0].bridgeUuid
            this.bridgeChange(this.bridgeName)
          } else {
            this.bridgeDatas = []
          }
        } else {
          this.bridgeData = []
        }
      }
    },
    // 搜索
    async onSubmit() {
      if (!this.bridgeUuid) {
        this.$message.error('请选择桥梁名称')
        return false
      } else if (!this.equipmentTypeUuid) {
        this.$message.error('请选择设备类型')
        return false
      } else if (!this.formInline.equipmentAnotherName) {
        this.$message.error('请选择设备列表')
        return false
      } else {
        await this.getSensorByNameAndCreateTime()
      }
    },
    // 获取实测数据
    async getSensorByNameAndCreateTime(num) {
      num
        ? (this.formInline.pageNum = num)
        : (this.formInline.pageNum = this.formInline.pageNum)
      const res = await this.$api.sendPost(
        '/dataDhSensor/getSensorByNameAndCreateTime',
        this.formInline
      )
      if (res.errcode === 0) {
        let dateArr = []
        let dataValue = []
        this.tableData = res.data.list
        this.total = res.data.total
        let arr = JSON.parse(JSON.stringify(res.data.list))
        arr.reverse().map((item) => {
          dateArr.push(item.createTime)
          dataValue.push(item.dataValue)
        })
        this.mathObj = {
            max: [],
            min: [],
            absMax: [],
            mean: '-',
            std: '-',
            peak:'-'
          }
        if(arr.length){
          const vals = arr.map(e => parseFloat(e.dataValue));
          const max    = Math.max(...vals);                    // 最大值
          const min    = Math.min(...vals);    
          const absMax = Math.max(...vals.map(Math.abs));                 // 最小值
          const absMax1 = Math.abs(max) > Math.abs(min) ? max : min; 
          const mean   = vals.reduce((a,b)=>a+b,0) / vals.length;  // 均值
          const std    = Math.sqrt(
            vals.reduce((a,b)=>a+(b-mean)**2,0) / vals.length   // 标准差（总体σ）
          );
          const peak   = max - min;
          let num = this.getMaxDecimalLength(arr)
          this.mathObj = {
            max: arr.filter(e => max == e.dataValue),
            min: arr.filter(e => min == e.dataValue),
            abs:absMax,
            absMax: arr.filter(e => absMax1 == e.dataValue),
            mean: mean.toFixed(num),
            std: std.toFixed(num),
            peak:peak.toFixed(num),
          }
          console.log(this.mathObj)
        }
        // 创建时间
        this.option.xAxis.data = dateArr
        this.option.yAxis.min = Math.min(...dataValue)
        // 数值
        this.option.series[0].data = dataValue
        this.option.series[0].smooth = true
        this.ChartOne()
      } else {
        this.tableData = []
      }
    },
    getMaxDecimalLength(arr) {
      let maxLen = 0;
      for (const item of arr) {
        const str = String(item.dataValue);
        if (str.includes('.')) {
          const decPart = str.split('.')[1];
          const len = decPart.length;
          if (len > maxLen) {
            maxLen = len;
          }
        }
        // 没有小数点，小数位=0，不更新maxLen
      }
      return maxLen;
    },
    // 导出事件
    exportItem(data) {
      axios({
        method: 'post',
        url: this.$config.host + '/dataDhSensor/exportList',
        data: data,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          this.btnLoading = false
          const link = document.createElement('a')
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
            // type: "application/pdf;charset=utf-8",  //.pdf
          })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = '数据导出' + '.xls' //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch((error) => {
          this.btnLoading = true
          // console.log(error)
        })
    },
    //图表
    async ChartOne() {
      this.echart = this.$echarts.init(document.querySelector('.charts'))
      let dom = document.querySelector('.charts')
      if (dom) {
        EleResize.on(dom, this.echart.resize)
        this.echart.setOption(this.option)
      }
    },
    typeChange(value) {
      console.log(value)
      if (value == 1) {
        this.listOptions = [
          {
            value: 1,
            label: '哈哈哈'
          },
          {
            value: 2,
            label: '啦啦啦'
          }
        ]
      } else if (value == 2) {
        this.listOptions = [
          {
            value: 1,
            label: '哈哈哈2'
          },
          {
            value: 2,
            label: '啦啦啦2'
          }
        ]
      } else {
        this.listOptions = []
      }
    },
    remoteReq() {}
  }
}
</script>

<style lang="scss" scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modul-content-title {
  // margin: 20px 0;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
}
.cardInfoBox{
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 15px;
    padding: 0 15px;
    color: #000;
    .card-item{
      background: #F3F9FF;
      border: 1px solid #a8e5e5;
      padding: 6px 15px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .el-dropdown [disabled]{
        color: #606266;
        cursor: unset;
      }
      >span{
        font-size: 13px;
        opacity: 0.6;
        &:last-of-type{
          font-size: 24px;
          font-weight: bold;
          opacity: 1;
        }
      }
      >div{
        font-size: 12px;
        ::v-deep .el-badge__content.is-fixed{
          right: 0.01rem;
        }
      }
    }
}

.echarts-box {
  width: 100%;

  .charts {
    width: 100%;
    height: 400px;
  }
}

::v-deep .el-dialog__body {
  height: 700px;
}

.bridge-data {
  overflow-y: auto;
  height: 600px;
  display: grid;
  grid-gap: 30px 25px;
  grid-template-columns: 260px 260px 260px 260px;
  padding-right: 30px;
}

.bridge-list {
  height: 500px;
}

.el-tree {
  padding-top: 15px;
  background: #f7f7f7;
}
.form-item-1 /deep/ .el-form--inline .el-form-item__content {
  width: 60px !important;
}
</style>
